import React from 'react';
import { PropTypes } from 'prop-types';
import { StyleSheet, css } from 'aphrodite';
import { Theme } from '../../config/theme';

let styles;
const FACEBOOK = require('./facebook.svg');
const MAIL = require('./mail.svg');

const ShareProfile = props => (
  <div className={css(styles.container)}>
    <div className={css(styles.information)}>Share this dog</div>
    <div className={css(styles.information)}>
      <a
        href={props.facebook}
        target="_blank"
        rel="noopener noreferrer"
      >
        <img src={FACEBOOK} alt="Share Facebook" className={css(styles.social_icon)} />
      </a>
      <a href={props.email} target="_blank" rel="noopener noreferrer">
        <img src={MAIL} alt="Email us" className={css(styles.social_icon, styles.mail_icon)} />
      </a>
    </div>
  </div>
);

ShareProfile.propTypes = {
  facebook: PropTypes.string.isRequired,
  email: PropTypes.string.isRequired,
};

export default ShareProfile;

styles = StyleSheet.create({
  container: {
    display: 'none',
  },
  heading: {
    marginBottom: 5,
    fontFamily: Theme.font_family_secondary,
    fontSize: 15,
    letterSpacing: 2,
    textTransform: 'uppercase',
    fontWeight: Theme.font_weight_heading,
    lineHeight: 1.73,
    color: '#000e1f',
  },
  social_icon: {
    maxWidth: 100,
    maxHeight: 100,
  },
  information: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
    margin: '0 auto 16px',

    [Theme.mobile_query]: {
      width: 'auto',
      flexWrap: 'wrap',
      justifyContent: 'center',
    },
  },
  copy: {
    position: 'relative',
    textAlign: 'left',
    lineHeight: 1.73,
    padding: '0 5px',

    [Theme.mobile_query]: {
      textAlign: 'center',
    },
  },
  osIcon: {
    maxWidth: 40,
    maxHeight: 40,
    margin: '0 10px',
    opacity: 1,
    transition: 'all 300ms',

    ':hover': {
      opacity: 0.6,
    },
  },
});



// WEBPACK FOOTER //
// ./src/components/ShareProfile/index.js